import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-financing',
  templateUrl: './financing.component.html',
  styleUrls: ['./financing.component.css'],
})
export class FinancingComponent implements OnInit {
  // This component handles the financing form for the COE application
  // It allows users to fill out the form, save it, and navigate through the application
  Financing: FormGroup;
  private saveApi = environment.url + 'coe/financing/save';
  private getApi = environment.url + 'coe/financing/get?id=';
  // This function initializes the form and sets up the necessary services
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.Financing = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      financingStartuptnContribution: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      financingHostIncContribution: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      financingIndustryContribution: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      financingRevenueGeneration: [
        '',
        [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      financingSponsorship: ['', [Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)]],
      financingTotal: [''],
    });
  }
  // This function retrieves the form controls for validation and display purposes
  resetForm(): void {
    if (this.getId == 0) {
      this.Financing.reset();
    }
  }
  // This function is called when the component is initialized
  ngOnInit(): void {
    this.getDataApi();
  }
  // This function calculates the total financing amount based on the individual contributions
  // It updates the total field in the form
  Optionsonechecked;
  calculateTotal1(): void {
    const year1 =
      parseFloat(this.Financing.get('financingStartuptnContribution')?.value) ||
      0;
    const year2 =
      parseFloat(this.Financing.get('financingHostIncContribution')?.value) ||
      0;
    const year3 =
      parseFloat(this.Financing.get('financingIndustryContribution')?.value) ||
      0;
    const year4 =
      parseFloat(this.Financing.get('financingRevenueGeneration')?.value) || 0;
    const year5 =
      parseFloat(this.Financing.get('financingSponsorship')?.value) || 0;
    const total = parseFloat(
      (year1 + year2 + year3 + year4 + year5).toFixed(2)
    );
    this.Financing.get('financingTotal')?.setValue(total);
  }

  showForm: boolean = false;
  get setting() {
    return this.Financing.controls;
  }

  getValue: any = {};
  disableBtn: boolean;
  show;
  getId;
  // This function retrieves the financing data from the API
  // It checks if the application is editable and updates the UI accordingly
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;

        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        this.getId = data.id;
        this.Financing.patchValue(data);
        if (data.responseStatus != 'Failed') {
          this.Financing.patchValue(data);
        }
      });
  }
  // This function navigates to the previous tab in the application
  cancleBtn() {
    this.showForm = false;
    this.Financing.reset();
  }
  // This function prevents the Enter key from submitting the form
  // It allows users to navigate through the form without triggering a submit action
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default action
    }
  }
  // This function saves the financing data to the API
  saveBtn() {
    let getform = this.Financing.value;
    if (this.Financing.invalid) {
      this.Financing.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      getform.applicationId = sessionStorage.getItem('applicationId');
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          this.router.navigateByUrl('admin/coe/revenue-generation');
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
    }
  }
  @Input() parent: any;
  // This function navigates to the next tab in the application
  previous() {
    this.parent.navigateToTab(2);
  }
}
